<template>
	<b-card :id="componentName" header="Reporte">
		<b-table class="m-0" striped responsive borderless :items="resultset" :fields="showingData">
			<!-- ESTATUS -->
			<template #cell(estatus)="data">
				<div :class="'item-' + data.item.estatus">
					<i class="fa fa-random" v-if="data.item.cambiado == '1'"></i>
					<i class="fa fa-circle-o" v-else-if="data.item.estatus == 'Pendiente'"></i>
					<i class="fa fa-check-circle-o" v-else></i>&nbsp;
					<span v-if="data.item.cambiado == '1'">{{ data.value }}, cambiado</span>
					<span v-else>{{ data.value }}</span>
				</div>
			</template>

			<!-- MONEDA -->
			<template #cell(costo)="data">{{ data.value | currency }}</template>
			<template #cell(venta)="data">{{ data.value | currency }}</template>

			<!-- PRESENTACION -->
			<template #cell(presentacion)="data">
				{{ data.item.tipo_presentacion }} 
				{{ data.value }}
				{{ data.item.unidadmedicion }}
			</template>
		</b-table>
	</b-card>
</template>

<script>
import axios from "axios";
export default {
	props: {
		originId: {
			type: [Number, String],
			default: null
		}
	},
	data: () => {
		return {
			componentName: "definicionCompras",
			resultset: [],
			showingData: [
				{
					key: "elemento",
					label: "Elemento",
					sortable: true
				},
				{
					key: "grupo",
					label: "Clasificación",
					sortable: true
				},
				{
					key: "presentacion",
					label: "Presentacion",
					sortable: true
				},
				{
					key: "marca",
					sortable: true
				},
				{
					key: "estatus",
					sortable: true
				},
				{
					key: "costo",
					sortable: true
				},
				{
					key: "venta",
					sortable: true
				},
				{
					key: "inventario",
					sortable: true,
					label: "Existencia"
				},
				{
					key: "cantidad",
					sortable: true
				},
				{
					key: "comprar",
					sortable: true
				},
				// {
				//   key: "tipo_presentacion",
				//   sortable: true
				// },
				// {
				//   key: "unidadmedicion",
				//   sortable: true
				// }
			]
		};
	},
	methods: {
		loadProducts() {
			this.resultset = [];
			axios.get("compras/getreport/" + this.originId).then(response => {
				if (response.status) {
					this.resultset = response.data;
				}
			});
		}
	},
	mounted() {
		this.loadProducts();
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

#definicionCompras {
	white-space: nowrap;
	overflow: hidden;

	.item-Existencia {
		i {
			color: $dimmed;
		}
	}

	.item-Inventariado {
		i {
			color: $blue;
		}
	}
}
</style>